import { useState } from "react";
import { base64Decoding, base64Encoding } from "../../../common/util";
import { FONT, SESSIONSTORAGE } from "../../../value/staticValues";

interface DashboardTopBtnProps {
    text: string;
    value: string;
    setValue: Function;
}
export default function DashboardTopBtn(props:DashboardTopBtnProps) {
    const [mouseOver, setMouseOver] = useState(false);

    function setDashboardStatus() {
        sessionStorage.setItem(SESSIONSTORAGE.DESHBOARD_VIEW, base64Encoding(props.text));
        props.setValue(props.text);
    }

    return (
        <div
            style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 121, height: 36,
                borderRadius: 10,
                border: "solid 1px #dcdfe6",
                backgroundColor: mouseOver || props.value === props.text ? "#4a77ff" : "#f2f4f7",
                fontFamily: FONT.MEDIUM,
                fontSize: 14,
                lineHeight: 0.93,
                color: mouseOver || props.value === props.text? "#fff" : "#9ea0a5",
                cursor: "pointer"
            }}
            onMouseOver={() => setMouseOver(true)}
            onMouseOut={() => setMouseOver(false)}
            onClick={() => {setDashboardStatus();}}
        >
            {props.text}
        </div>
    )
}